<template lang="html">

 <section class="admin-dashboard">
    <div class="pageHeading">
      <v-layout row wrap>
        <v-flex xs12 md6>
          <h1>Admin Dashboard</h1>
        </v-flex>
        <v-flex xs12 md6>

          <v-autocomplete
                  v-model="$filterTripID"
                  :items="$structuredData.trips"
                  @change="selectedResult = null"
                  color="black"
                  hide-no-data
                  hide-selected
                  item-text="prettyName"
                  item-value="_id"
                  label="Limit To Trip ID"
                  persistent-hint
                  solo
                  prepend-icon="mdi-database-search"
                  return-object
          ></v-autocomplete>


        </v-flex>
      </v-layout>
    </div>
    <v-container  grid-list-md text-xs-center>
      <v-layout row wrap>



        <participant-edit-form v-on:closeDialog="openParticipantEditDialog=false" v-on:alertUser="(result, message) => {this.$emit('alertUser', result, message); openParticipantEditDialog=false;}" v-bind:dialog="openParticipantEditDialog" v-bind:participant="selectedResult"></participant-edit-form>

        <void-payment v-on:closeDialog="openPaymentVoidDialog=false"
                      v-on:alertUser="(result, message) => {this.$emit('alertUser', result, message);}"
                      v-bind:dialog="openPaymentVoidDialog" v-bind:payment="selectedPayment"></void-payment>

        <v-flex xs12>

          <v-card elevation="5">



              <v-toolbar
                      color="primary"
                      dark
                      tabs
              >
                <v-text-field

                        flat
                        v-model="filterQuery"
                        @click="selectedResult = null"
                        @click:clear="selectedResult = null"
                        label="Search"
                        prepend-inner-icon="search"
                        solo-inverted
                        clearable
                ></v-text-field>
              </v-toolbar>


            <v-container  v-if="filterQuery != null && filterQuery.length > 0">

              <v-divider></v-divider>

              <v-layout row wrap>
                <v-flex :xs12="selectedResult == null" :xs4="selectedResult != null">


              <v-list subheader three-line>
                <v-subheader>Results</v-subheader>


                <v-list-tile avatar v-for="item in filteredResults"
                             v-bind:class="{ selectedSearchResult: item==selectedResult }"
                             @click="selectedResult = item; getSelectedParticipantNotes()" >
                  <v-list-tile-avatar>
                    <v-icon>{{item.icon}}</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title><h3>{{item.firstName + ' ' + item.middleName + ' ' + item.lastName}}</h3></v-list-tile-title>
                    <v-layout row wrap>
                      <v-flex>
                        <span>{{item.email}}</span>
                          <br/>
                          <span>{{item.phone}}</span>
                      </v-flex>

                    </v-layout>

                  </v-list-tile-content>


                </v-list-tile>

              </v-list>



                </v-flex>
                <v-flex  xs8 v-if="selectedResult != null" style="border-left: 1px #e0e0e0 solid;">

                  <v-card
                  >
                      <v-tabs v-model="tabs"
                              color="#c9ceea"
                              grow

                              slider-color="black"
                      >
                        <v-tab
                                key="1"
                                ripple
                        >
                          Summary

                        </v-tab>


                        <v-tab
                                key="2"
                                ripple
                        >
                          Payment/Fundraising

                        </v-tab>

                          <v-tab
                                  key="3"
                                  ripple
                          >
                              Messages

                          </v-tab>

                        <v-tab-item
                                key="1"
                        >

                          <v-subheader class="participantSummarySubHeader">Participant
                            <v-btn :disabled="resetPasswordWorking" @click="resetUserPassword(selectedResult.ParentUser)" color="secondary" small >{{resetPasswordWorking ? 'Resetting Password...' : 'Reset Password'}}</v-btn>

                            <v-btn color="secondary" @click="participantToEdit = null; participantToEdit = selectedResult; openParticipantEditDialog = true" small >Edit Participant</v-btn>
                              <v-btn :disabled="setStatusWorking" v-if="!selectedResult.disabled" color="red" @click="SetParticipantStatus(selectedResult, true)" small >Disable</v-btn>
                              <v-btn :disabled="setStatusWorking" v-else color="green" @click="SetParticipantStatus(selectedResult, false)" small >Enable</v-btn>
                            <v-btn :disabled="setStatusWorking" v-if="!selectedResult.lateFeesDisabled" color="red" @click="DisableParticipantLateFees(selectedResult, true)" small >Disable Late Fees</v-btn>
                            <v-btn :disabled="setStatusWorking" v-else color="green" @click="DisableParticipantLateFees(selectedResult, false)" small >Enable Late Fees</v-btn>
                          </v-subheader>

                          <v-layout row wrap class="summaryParticipantBoxes">
                            <v-flex xs3 >
                              <span class="topTextBottomLabels">{{selectedResult.firstName + ' '+ selectedResult.middleName + ' ' + selectedResult.lastName}}</span>
                              <br/>
                              <strong class="bottomLabels">{{selectedResult.email}}</strong>
                            </v-flex>
                            <v-flex xs3 >
                              <span class="topTextBottomLabels">{{selectedResult.parentEmail}}</span>
                              <br/>
                              <strong class="bottomLabels"> <router-link :to="'/Profile/' + selectedResult.ParentUser">Parent User</router-link></strong>
                            </v-flex>
                            <v-flex xs2>
                              <span class="topTextBottomLabels">{{selectedResult.Occupancy}}</span>
                              <br/>
                              <strong class="bottomLabels">Occupancy</strong>

                            </v-flex>
                            <v-flex xs4>
                              <span class="topTextBottomLabels">{{selectedResult.phone}}</span>
                              <br/>
                              <strong class="bottomLabels">Phone Number</strong>
                            </v-flex>



                          </v-layout>

                          <v-divider></v-divider>




                          <v-layout row wrap class="summaryParticipantBoxes">
                            <v-flex xs2 >
                              <span class="topTextBottomLabels">{{selectedResult.gender}}</span>
                              <br/>
                              <strong class="bottomLabels">Gender</strong>
                            </v-flex>
                            <v-flex xs2>
                              <span class="topTextBottomLabels">{{selectedResult.DOB | moment("MM-DD-YYYY")}}</span>
                              <br/>
                              <strong class="bottomLabels">DOB</strong>

                            </v-flex>
                            <v-flex xs1>
                              <span class="topTextBottomLabels">{{selectedResult.type}}</span>
                              <br/>
                              <strong class="bottomLabels">Type</strong>
                            </v-flex>


                            <v-flex xs7>
                              <span class="topTextBottomLabels">{{selectedResult.allergies}}</span>
                              <br/>
                              <strong class="bottomLabels">Dietary Restrictions</strong>
                            </v-flex>


                          </v-layout>

                          <v-divider></v-divider>




                          <v-layout row wrap class="summaryParticipantBoxes">
                            <v-flex  >
                              <span class="topTextBottomLabels">${{selectedResult.totalFundRaised.toFixed(2)}}</span>
                              <br/>
                              <strong class="bottomLabels">Fundraising</strong>

                            </v-flex>
                            <v-flex >
                              <span class="topTextBottomLabels">${{selectedResult.totalPaid.toFixed(2)}}</span>
                              <br/>
                              <strong class="bottomLabels">Payments</strong>
                            </v-flex>
                            <v-flex >
                              <span class="topTextBottomLabels">${{selectedResult.totalFee.toFixed(2)}}</span>
                              <br/>
                              <strong class="bottomLabels">Fees</strong>
                            </v-flex>
                              <v-flex>
                                  <span class="topTextBottomLabels">${{selectedResult.totalPending.toFixed(2)}}</span>
                                  <br/>
                                  <strong class="bottomLabels">Pending</strong>
                              </v-flex>
                            <v-flex >
                              <span class="topTextBottomLabels">${{selectedResult.selectedTripCost}}</span>
                              <br/>
                              <strong class="bottomLabels">Trip Cost</strong>
                            </v-flex>

                              <v-flex >
                                  <span class="">${{selectedResult.totalRemaining.toFixed(2)}}</span>
                                  <br/>
                                  <strong class="bottomLabels">Total Remaining</strong>
                              </v-flex>

                            <v-flex >
                              <span class="topTextBottomLabels">${{selectedResult.dueAmount.toFixed(2) }}</span>
                              <br/>
                              <strong class="bottomLabels">Next Due</strong>
                            </v-flex>

                            <v-flex >
                              <span class="topTextBottomLabels">{{selectedResult.nextDue | moment("MM-DD-YYYY")}}</span>
                              <br/>
                              <strong class="bottomLabels">Due Date</strong>
                            </v-flex>

                          </v-layout>


                          <v-divider></v-divider>


                          <v-layout row wrap >
                          <v-flex >

                            <v-text-field
                                     v-model="selectedParticipantNotes"
                                    full-width
                                    hide-details
                                    color="black"
                                    label="Internal Notes"

                            >
                            </v-text-field>

                          </v-flex>
                            <v-flex xs2>
                              <v-btn x-small @click="saveParticipantNote(selectedResult)"><v-icon>save</v-icon></v-btn>
                            </v-flex>
                          </v-layout>


                          <div v-if="selectedResult.Fees.length > 0">
                          <v-divider></v-divider>


                          <v-subheader class="participantSummarySubHeader">Overdue Payment(s)</v-subheader>



                          <v-data-table class="overdueTable"  hide-actions :headers="[
              {
                text: 'Installment #',
                align: 'left',
                value: 'name',
                sortable:false
              },
              {
                  text: 'Overdue',
                  sortable:false ,
                  value: 'phone'
              },
              {
                  text: 'Unpaid',
                  sortable:false ,
                  value: 'phone'
              },
              {
                  text: 'Fee',
                  value: 'email',
                  sortable:false
              },
              {
                  text: '',
                  value: 'action',
                sortable:false
              }
          ]" :items="selectedResult.Fees"
                          >
                            <template slot="items" slot-scope="props">
                              <tr style="color: red" v-bind:class="{ waivedFee: props.item.Waived }" >
                                <td>{{props.item.Installment}}</td>
                                <td class="text-xs-left">{{props.item.daysOverdue + ' day(s)'}}</td>
                                <td class="text-xs-left">$200</td>
                                <td class="text-xs-left">${{props.item.Amount}}</td>
                                <td class="text-xs-left">
                                  <v-btn @click="$waiveFeed(props.item)" v-if="!props.item.Waived" color="secondary" small >Waive Fee</v-btn>
                                  <span v-else>Waived</span>
                                </td>

                              </tr>
                            </template>

                          </v-data-table>

                          </div>

                          <v-divider></v-divider>



                          <v-subheader class="participantSummarySubHeader">Payments</v-subheader>


                          <v-data-table class="paymentSummaryTable" hide-actions :headers="[

{
                text: 'Status',
                align: 'left',
                value: 'status'
              },
{
                text: 'Type',
                align: 'left',
                value: 'type'
              },
              {
                text: 'Billing Name',
                align: 'left',
                value: 'name'
              },
              {
                  text: 'Last 4#',
                  align: 'left',
                  value: 'endingDigits'
              },
              {
                  text: 'Amount',
                  value: 'amount'
              },
              {
                  text: 'Date',
                  value: 'date'
              },

              {
                  text: 'Transaction Ref',
                  value: 'phone'
              },
              {
                  text: 'StatusNote',
                  value: 'StatusNote'
              },
              {
                  text: 'Notes',
                  value: 'Notes'
              },
              {
                  text: '',
                  value: 'Voiding'
              }
          ]" :items="selectedResult.Payments"
                          >
                            <template slot="items" slot-scope="props">
                              <tr >
                                <td class="text-xs-left">{{ props.item.Status  }}</td>
                                <td class="text-xs-left">{{ props.item.Type  }}</td>
                                <td>{{ props.item.BillingName}}</td>
                                <td class="text-xs-left">{{props.item.Last4}}</td>
                                <td class="text-xs-left">${{ props.item.Amount }}</td>
                                <td class="text-xs-left">{{ props.item.Date | moment("MM-DD-YYYY") }}</td>

                                <td class="text-xs-left">{{props.item.TransRef}}</td>
                                <td class="text-xs-left">{{props.item.StatusNote}} - {{ props.item.StatusNoteDate | moment("MM-DD-YYYY") }}</td>
                                <td class="text-xs-left">{{props.item.Notes}}</td>
                                <td class="text-xs-left">
                                  <v-btn v-if="props.item.Status !== 'Voided'" color="red" dark @click="selectedPayment = props.item.id;  openPaymentVoidDialog = true" small >Void Payment</v-btn>
                                </td>

                              </tr>
                            </template>

                          </v-data-table>


                        </v-tab-item>

                        <v-tab-item
                                key="2"
                        >
                          <payment-form v-bind:participant="[selectedResult]"
                                        v-on:alertUser="(result, message) => {this.$emit('alertUser', result, message);}"></payment-form>
                        </v-tab-item>

                          <v-tab-item key="3">
                              <trip-messages  v-bind:showCreate="true" v-bind:selectedUser="selectedResult.ParentUser">

                              </trip-messages>

                          </v-tab-item>

                      </v-tabs>

                  </v-card>


                </v-flex>
              </v-layout>

            </v-container>
          </v-card>


          <v-divider inset></v-divider>
          <br/>

        </v-flex>
      </v-layout>



    </v-container>

     <v-container class="tripInfoContainer" grid-list-md text-xs-center v-if="$structuredData.selectedTrip != undefined">
         <v-layout row wrap>
             <v-flex md12 xs12>
                 <v-card elevation="5">
                     <v-container>
                         <v-layout row wrap>
                             <v-flex xs12 text-xs-center >

                                     <h3>{{$structuredData.selectedTrip.prettyName}}</h3>

                                     <div class="paymentDueDates">
                                     <span class="paymentDueDate paymentDueDate--deposit"><span class="paymentDueHeading"><v-icon v-if="isPastDueDate($structuredData.selectedTrip.depositPaymentDueDate)" class="paymentDueDate__pastIcon" title="Due date has passed">history</v-icon><small class="paymentDueLabel">Deposit</small></span><span>{{$structuredData.selectedTrip.depositPaymentDueDate | moment("MM-DD-YYYY")}}</span></span>
                                     <v-icon>forward</v-icon>
                                     <span class="paymentDueDate paymentDueDate--installment1"><span class="paymentDueHeading"><v-icon v-if="isPastDueDate($structuredData.selectedTrip.firstPaymentDueDate)" class="paymentDueDate__pastIcon" title="Due date has passed">history</v-icon><small class="paymentDueLabel">Installment 1</small></span><span>{{$structuredData.selectedTrip.firstPaymentDueDate  | moment("MM-DD-YYYY")}}</span></span>
                                     <v-icon>forward</v-icon>
                                     <span class="paymentDueDate paymentDueDate--installment2"><span class="paymentDueHeading"><v-icon v-if="isPastDueDate($structuredData.selectedTrip.secondPaymentDueDate)" class="paymentDueDate__pastIcon" title="Due date has passed">history</v-icon><small class="paymentDueLabel">Installment 2</small></span><span>{{$structuredData.selectedTrip.secondPaymentDueDate  | moment("MM-DD-YYYY")}}</span></span>
                                     <v-icon>forward</v-icon>
                                     <span class="paymentDueDate paymentDueDate--installment3"><span class="paymentDueHeading"><v-icon v-if="isPastDueDate($structuredData.selectedTrip.thirdPaymentDueDate)" class="paymentDueDate__pastIcon" title="Due date has passed">history</v-icon><small class="paymentDueLabel">Installment 3</small></span><span>{{$structuredData.selectedTrip.thirdPaymentDueDate  | moment("MM-DD-YYYY")}}</span></span>
                                     <v-icon>forward</v-icon>
                                     <span class="paymentDueDate paymentDueDate--installment4"><span class="paymentDueHeading"><v-icon v-if="isPastDueDate($structuredData.selectedTrip.finalPaymentDueDate)" class="paymentDueDate__pastIcon" title="Due date has passed">history</v-icon><small class="paymentDueLabel">Installment 4</small></span><span>{{$structuredData.selectedTrip.finalPaymentDueDate  | moment("MM-DD-YYYY")}}</span></span>
                                     </div>

                             </v-flex>
                         </v-layout>
                     <v-layout row wrap>
                         <v-flex xs6>

                             <v-flex text-xs-left xs12 style="border-bottom: grey 1px solid">
                                 <h4>Quad Occupancy</h4>
                             </v-flex>
                             <v-flex xs12>
                                 <p>${{$structuredData.selectedTrip.depositAmount}} deposit + ${{$structuredData.selectedTrip.quadInstallments}} * 4 installments = ${{$structuredData.selectedTrip.quadPrice}}</p>
                             </v-flex>


                         </v-flex>

                         <v-flex xs6>

                             <v-flex text-xs-left xs12 style="border-bottom: grey 1px solid">
                                 <h4>Triple Occupancy</h4>
                             </v-flex>
                             <v-flex xs12>
                                 <p>${{$structuredData.selectedTrip.depositAmount}} deposit + ${{$structuredData.selectedTrip.tripleInstallments}} * 4 installments = ${{$structuredData.selectedTrip.triplePrice}}</p>
                             </v-flex>


                         </v-flex>

                         <v-flex xs6>

                             <v-flex text-xs-left xs12 style="border-bottom: grey 1px solid">
                                 <h4>Double Occupancy</h4>
                             </v-flex>
                             <v-flex xs12>
                                 <p>${{$structuredData.selectedTrip.depositAmount}} deposit + ${{$structuredData.selectedTrip.doubleInstallments}} * 4 installments = ${{$structuredData.selectedTrip.doublePrice}}</p>
                             </v-flex>


                         </v-flex>

                         <v-flex xs6>

                             <v-flex text-xs-left xs12 style="border-bottom: grey 1px solid">
                                 <h4>Single Occupancy</h4>
                             </v-flex>
                             <v-flex xs12>
                                 <p>${{$structuredData.selectedTrip.depositAmount}} deposit + ${{$structuredData.selectedTrip.singleInstallments}} * 4 installments = ${{$structuredData.selectedTrip.singlePrice}}</p>
                             </v-flex>


                         </v-flex>
                     </v-layout>

                     </v-container>
                 </v-card>
             </v-flex>
         </v-layout>
     </v-container>


   <v-container grid-list-md text-xs-center>
       <v-layout row wrap>
           <v-flex md12 xs12>

               <v-card elevation="5">

                   <div >

                       <v-card-title primary-title>

                           <v-flex xs2 text-xs-center>

                           </v-flex>

                           <v-flex xs8 text-xs-center>
                               <h3 class="headline mb-0">Travelers Status</h3>
                               <div>List of the newest registrations for this trip</div>
                           </v-flex>

                           <v-flex xs2 text-xs-center>
                               <v-btn @click="exportToExcel"  color="secondary"
                               ><v-icon style="margin-right: 10px" dark>cloud_download</v-icon> Export Report
                               </v-btn>
                           </v-flex>



                       </v-card-title>


                       <v-container   style="border-top: lightgray 1px solid; padding: 5px; padding-bottom: 0px; "  >

                           <v-layout v-ripple row wrap class="tripStatBoxes">
                               <v-flex @click="applyFilter('all')" v-bind:class="{ selectedFilter: filter == 'all' }" >
                                  <span class="topTextBottomLabels">
                                      {{filteredByGroupParticipants.length}}
                                  </span>
                                   <br/>
                                   <strong class="bottomLabels">Registrations</strong>

                               </v-flex>
                               <v-flex @click="applyFilter('fr')" v-bind:class="{ selectedFilter: filter == 'fr' }">
                                  <span class="topTextBottomLabels">
                                      {{filteredByGroupParticipants.filter((participant) => participant.totalFundRaised > 0).length}}
                                  </span>
                                   <br/>
                                   <strong class="bottomLabels">Fundraisers</strong>
                               </v-flex>
                               <v-flex @click="applyFilter('mp')" v-bind:class="{ selectedFilter: filter == 'mp' }">
                                  <span class="topTextBottomLabels">
                                      {{filteredByGroupParticipants.filter((participant) => participant.totalPaid > 0).length}}
                                  </span>
                                   <br/>
                                   <strong class="bottomLabels">Made Payment</strong>
                               </v-flex>
                               <v-flex @click="applyFilter('fp')" v-bind:class="{ selectedFilter: filter == 'fp' }">
                                  <span class="topTextBottomLabels">
                                      {{filteredByGroupParticipants.filter((participant) => (participant.totalPaid + participant.totalFundRaised) >= participant.selectedTripCost).length}}
                                  </span>
                                   <br/>
                                   <strong class="bottomLabels">Fully Paid</strong>
                               </v-flex>
                               <v-flex @click="applyFilter('pd')" v-bind:class="{ selectedFilter: filter == 'pd' }">
                                  <span class="topTextBottomLabels">
                                      {{filteredByGroupParticipants.filter((participant) =>  participant.dueAmount > 0 && participant.daysToDue < 3  && participant.daysToDue >= 0).length}}
                                  </span>
                                   <br/>
                                   <strong class="bottomLabels">Payment Due</strong>
                               </v-flex>
                               <v-flex @click="applyFilter('po')" v-bind:class="{ selectedFilter: filter == 'po' }">
                                  <span class="topTextBottomLabels">
                                      {{filteredByGroupParticipants.filter((participant) =>   participant.dueAmount > 0 && participant.daysToDue < 0).length}}
                                  </span>
                                   <br/>
                                   <strong class="bottomLabels">Payment Overdue</strong>
                               </v-flex>
                               <v-flex @click="applyFilter('op')" v-bind:class="{ selectedFilter: filter == 'op' }">
                                  <span class="topTextBottomLabels" style="color:red">
                                      {{filteredByGroupParticipants.filter((participant) => (participant.totalPaid + participant.totalFundRaised) > participant.selectedTripCost + participant.totalFee).length}}
                                  </span>
                                   <br/>
                                   <strong class="bottomLabels">Over Paid</strong>
                               </v-flex>
                             <v-flex @click="applyFilter('disabled')" v-bind:class="{ selectedFilter: filter == 'disabled' }">
                                  <span class="topTextBottomLabels" style="color:red">
                                      {{filteredByGroupParticipants_Disabled.length}}
                                  </span>
                               <br/>
                               <strong class="bottomLabels">Disabled</strong>
                             </v-flex>
                           </v-layout>

                       </v-container>



                       <v-card-actions v-if="$filterTripID != null && $filterTripID.customOptions != undefined && $filterTripID.customOptions.length > 0">
                           <v-layout  row wrap justify-content-center align-items-center style="border-top: lightgray 1px solid;">

                               <v-flex >
                                   <v-divider  class="ma-1"></v-divider>
                                   <h4>Filter By Group:</h4>
                                   <v-divider class="ma-1"></v-divider>
                               </v-flex>
                               <v-flex fluid v-for="option in $filterTripID.customOptions">
                                   <v-checkbox  class="ma-1" v-model="participantGroupFilter"
                                                hide-details :value="option.ID" :label="option.label" ></v-checkbox>
                               </v-flex>
                           </v-layout>

                       </v-card-actions>

                   </div>

                   <div v-show="this.filter != ''" style="border-top: 2px solid black;     margin-top: 2px;">




                       <v-data-table :rows-per-page-items="[30, 50, 100, {'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                     :pagination.sync="pagination" :headers="[
              {
                text: 'Name / Email',
                align: 'left',
                value: 'firstName'
              },
              {
                  text: 'Phone / Gender',
                  value: 'gender'
              },
              {
                  text: 'Fundraising / Total Paid',
                  value: 'totalFundRaised'
              },

              {
                  text: 'Trip Cost / Remaining',
                  value: 'totalRemaining'
              },
              {
                  text: 'Next Payment / Due Date',
                  value: 'selectedTripCost'
              }
          ]" :items="filteredParticipants"
                       >
                           <template slot="items" slot-scope="props">
                               <tr style="cursor: pointer"  @click.stop="selectAParticipant(props.item)">
                                   <td>{{ props.item.firstName + ' ' + props.item.lastName  }}
                                       <br/>
                                       {{ props.item.email }}
                                       </td>
                                   <td>{{ props.item.gender}}
                                       <br/>
                                       {{ props.item.phone }}</td>

                                   <td>${{ props.item.totalFundRaised.toFixed(2)}}<br/>${{ props.item.totalPaid.toFixed(2) }}</td>


                                   <td>${{ props.item.selectedTripCost.toFixed(2)}}
                                       <br/>
                                       ${{ props.item.totalRemaining.toFixed(2)}}</td>

                                   <td>${{ props.item.dueAmount.toFixed(2)}}
                                       <br/>
                                       {{ props.item.nextDue | moment("MM-DD-YYYY")}}</td>

                               </tr>

                           </template>

                       </v-data-table>

                   </div>
               </v-card>

           </v-flex>

       </v-layout>
   </v-container>

   <v-container grid-list-md text-xs-center >

      <v-layout row wrap>
        <v-flex xs12 md6>

            <v-card  elevation="5">
                <v-card-title primary-title>
                    <v-flex>
                        <h3 class="headline mb-0">Fundraising</h3>
                        <div>Apply fundraising to one or more participants</div>
                    </v-flex>
                </v-card-title>

                <v-card-actions>
                    <v-layout row wrap>
                        <v-flex

                                pa-1  style="border-top: lightgray 1px solid;">

                            <v-btn @click="$router.push('/FundRaising')" color="primary">Add New</v-btn>
                        </v-flex>
                    </v-layout>

                </v-card-actions>
            </v-card>

            <br/>


          <v-card elevation="5">

            <v-card-title primary-title>
              <v-flex xs12 text-xs-center>
                <h3 class="headline mb-0">Overdue Participants</h3>
                <div>List of the payment progress for participants of all (or selected) trips</div>
              </v-flex>



            </v-card-title>


            <v-container style="border-top: lightgray 1px solid; max-height: 500px; overflow-y: scroll;">

              <v-timeline
                      dense
              >


          <v-timeline-item v-for="participant in $structuredData.participants" v-if="participant.daysToDue < 0 && !participant.disabled"

                           :color="participant.color"
                           small
                           icon="date_range"
          >
            <v-layout pt-3 style="cursor: pointer"
                      >
              <v-flex xs6>

                <small v-if="participant.lateFeesDisabled" style="color: red">Fees Disabled </small>
                <strong>{{participant.firstName + ' ' + participant.lastName}}</strong>
                <br/>

                <strong v-bind:style="{ color: participant.color }">Payment Due {{participant.nextDue | moment("MMM Do")}}</strong>

                <div class="caption"></div>
              </v-flex>
              <v-flex>
                <div class="caption">

                  <v-progress-linear class="paymentMeterBar"  v-model="participant.percentPaid"></v-progress-linear>
                  <span><strong>${{participant.totalFundRaised + participant.totalPaid}}</strong> of ${{participant.selectedTripCost}}</span>
                </div>
              </v-flex>

            </v-layout>


            <v-layout row wrap v-show="participant == expanded">
              <v-flex

                      pa-1  style="border-bottom: lightgray 1px solid;">

                <v-btn color="primary" dark small>Add Payment</v-btn>
                <v-btn color="#af0b0b" small dark>Add Fee</v-btn>
              </v-flex>
            </v-layout>

          </v-timeline-item>
              </v-timeline>
            </v-container>
          </v-card>

        </v-flex>
        <v-flex xs12 md6>

          <v-card  elevation="5">
            <v-card-title primary-title>
              <v-flex>
                <h3 class="headline mb-0">Mass Adjust</h3>
                <div>Make mass adjustments</div>
              </v-flex>
            </v-card-title>

            <v-card-actions>
              <v-layout row wrap>
                <v-flex

                    pa-1  style="border-top: lightgray 1px solid;">

                  <v-btn @click="$router.push('/MassAdjustment')" color="primary">Add New</v-btn>
                </v-flex>
              </v-layout>

            </v-card-actions>
          </v-card>
          <br/>
          <trip-messages  v-bind:showCreate="$filterTripID != null" v-bind:selectedTrip="$filterTripID">

          </trip-messages>
        </v-flex>
      </v-layout>
    </v-container>
  </section>

</template>

<script lang="js">
    import tripMessages from '../components/TripMessages'
    import paymentForm from '../components/PaymentForm'
    import participantEditForm from '../components/ParticipantInfoDialog'
    import voidPayment from '../components/VoidPayment'
    import XLSX from 'xlsx'
    import moment from'moment';
  export default  {
    name: 'admin-dashboard',
      props: [],
      components: {
          tripMessages,
          paymentForm,
          participantEditForm,
          voidPayment
      },
      mounted() {

      },
      data() {
          return {
              pagination: {
                  rowsPerPage: 30
              },
              selectedParticipantNotes:'',
              userMessage: {},
              openParticipantEditDialog: false,
              openPaymentVoidDialog: false,
              selectedPayment: null,
              participantGroupFilter: [],
              selectedResult: null,
              dialog: false,
              tabs: 0,
              filterQuery: '',
              tripFilter: null,
              expanded: null,
              resetPasswordWorking: false,
              setStatusWorking: false,
              filter: 'all'

          }
      },
      methods: {
        isPastDueDate(date) {
          if (!date) return false

          const dueDate = new Date(String(date).slice(0, 10) + 'T00:00:00')
          if (isNaN(dueDate.getTime())) return false

          const today = new Date()
          today.setHours(0, 0, 0, 0)
          return dueDate < today
        },
        exportToExcel() {
          var wb = XLSX.utils.book_new();


//Vue.prototype.$userData = {"new": true}

          var ws_name = "SheetJS";

          /* make worksheet */
          var ws_data = [
            ["ID", "First Name", "Middle Name", "Last Name", "Email", "Phone Number", "Gender", "Type", "DOB", "Occupancy", "Group", "Dietary Restrictions",
              "Trip Cost", "Fundraising Total", "CC / Check Total", "Next Due Amount", "Next Due Date", "Total Remaining"]
          ];

          this.filteredParticipants.forEach((participant) => {
            let row = []
            row.push(participant._id)
            row.push(participant.firstName)
            row.push(participant.middleName)
            row.push(participant.lastName)
            row.push(participant.email)
            row.push(participant.phone)
            row.push(participant.gender)
            row.push(participant.type)
            row.push(participant.DOB)
            row.push(participant.Occupancy)
            row.push(participant.GroupsPretty)
            row.push(participant.allergies)
            row.push(participant.selectedTripCost)
            row.push(participant.totalFundRaised)
            row.push(participant.totalPaid)
            row.push(participant.dueAmount)
            row.push(moment(participant.nextDue).format('MM-DD-YYYY'))
            row.push(participant.totalRemaining)
            ws_data.push(row)
          })


          var ws = XLSX.utils.aoa_to_sheet(ws_data);

          /* Add the worksheet to the workbook */
          XLSX.utils.book_append_sheet(wb, ws, ws_name);

          let identifier = ''

          switch (this.filter) {
            case 'op':
              identifier = '_Over_Paid'
              break;
            case 'fr':
              identifier = '_Fundraised'
              break;
            case 'mp':
              identifier = '_Made_Payment'
              break;
            case 'pd':
              identifier = '_Payment_Due'
              break;
            case 'po':
              identifier = '_Payment_Overdue'
              break;
            case 'disabled':
              identifier = '_Disabled'
              break;
            case 'all':
              identifier = '_Registered'
              break;
            default:
              identifier = ''
              break;
          }

          XLSX.writeFile(wb, 'Trip_' + this.$structuredData.selectedTrip.tripID + '_Participants_Export' + identifier + '.xlsx');

        },
        getSelectedParticipantNotes(){
          console.log('updating notes', this.selectedResult)
          if(this.selectedResult.notes != null && this.selectedResult.notes != undefined) {
            this.selectedParticipantNotes = this.selectedResult.notes
          } else {
            this.selectedParticipantNotes = ''
          }
        },
          selectAParticipant(item) {
            this.filterQuery = item.email
              this.selectedResult = item
            this.getSelectedParticipantNotes()
          },

        saveParticipantNote(participant) {
          var vueThis = this
          vueThis.setStatusWorking = true
          this.$services.participants.patch(participant._id,
              {"notes":this.selectedParticipantNotes}).then((result) => {
            vueThis.$updateParticipant(participant._id, result)
            vueThis.$emit("alertUser", "success", "Participant Notes Saved!!")
            vueThis.setStatusWorking = false

          }).catch(function (error) {
            console.error('update Error!', error);
            vueThis.setStatusWorking = false
            vueThis.$emit("alertUser", "error", "There was an error processing your request")

          });
        },
        DisableParticipantLateFees(participant, disabled) {
          var vueThis = this
          vueThis.setStatusWorking = true
          this.$services.participants.patch(participant._id,
              {"lateFeesDisabled":disabled}).then((result) => {
            vueThis.$updateParticipant(participant._id, result)
            vueThis.$emit("alertUser", "success", "Participant Updated!!")
            vueThis.setStatusWorking = false

          }).catch(function (error) {
            console.error('update Error!', error);
            vueThis.setStatusWorking = false
            vueThis.$emit("alertUser", "error", "There was an error processing your request")

          });
        },
          SetParticipantStatus(participant, disabled) {
            var vueThis = this
              vueThis.setStatusWorking = true
            var overideAutoDisabled = undefined
            if(participant.disabled === true && disabled === false) {
              overideAutoDisabled = true
            }

              this.$services.participants.patch(participant._id,
                  {"disabled":disabled, "overideAutoDisabled" : overideAutoDisabled}).then((result) => {
                  vueThis.$updateParticipant(participant._id, result)
                  vueThis.$emit("alertUser", "success", "Participant Updated!!")
                  vueThis.setStatusWorking = false

              }).catch(function (error) {
                  console.error('update Error!', error);
                  vueThis.setStatusWorking = false
                  vueThis.$emit("alertUser", "error", "There was an error processing your request")

              });
          },
          applyFilter(filter) {
              if(this.filter != filter) {
                  this.filter = filter
              } else {
                  this.filter = 'all'
              }
              console.log('filter11111111111', filter)

          },
          resetUserPassword(user) {
              var vueThis = this
              this.resetPasswordWorking = true
              this.$services.authmanagement.create({
                  "action": "sendResetPwd",
                  "value": { "email": user.email}

              }).then(()=>{
                  vueThis.$emit("alertUser", "success", "Password Reset Email Sent!")
                  this.resetPasswordWorking = false
              }).catch((err)=>{
                  vueThis.$emit("alertUser", "error", "Failed to reset email")
                  this.resetPasswordWorking = false
              })
          },
        expand() {

        }

      },
      computed: {
          filteredParticipants() {
              var toReturn = []


                this.$structuredData.participants.forEach((participant)=>{
                    if(!participant.disabled || this.filter === 'disabled') {
                        var clearedGroup = true;

                        if (this.participantGroupFilter.length > 0) {
                            participant.Group.forEach((group) => {
                                clearedGroup = this.participantGroupFilter.includes(group)
                            })
                        }


                        if (clearedGroup) {
                            if (this.filter == 'all') {
                                toReturn.push(participant)
                            } else if (this.filter == 'fr' && participant.totalFundRaised > 0) {
                                toReturn.push(participant)
                            } else if (this.filter == 'mp' && participant.totalPaid > 0) {
                                toReturn.push(participant)
                            } else if (this.filter == 'fp' && (participant.totalPaid + participant.totalFundRaised) >= participant.selectedTripCost) {
                                toReturn.push(participant)
                            } else if (this.filter == 'op' && (participant.totalPaid + participant.totalFundRaised) > (participant.selectedTripCost + participant.totalFee)) {
                                toReturn.push(participant)
                            } else if (this.filter == 'pd' && participant.dueAmount > 0 && participant.daysToDue < 3 && participant.daysToDue >= 0) {
                                toReturn.push(participant)
                            } else if (this.filter == 'po' && participant.daysToDue < 0 && participant.dueAmount > 0) {
                                toReturn.push(participant)
                            } else if (this.filter == 'disabled' && participant.disabled === true) {
                              toReturn.push(participant)
                            }
                        }
                    }
             })

              return toReturn

          },
        filteredByGroupParticipants_Disabled() {
          console.log('in filteredByGroupParticipants Disabled')
          var toReturn = []

          this.$structuredData.participants.forEach((participant)=>{
            if(participant.disabled) {
              if (this.participantGroupFilter.length > 0) {
                participant.Group.forEach((group) => {
                  if (this.participantGroupFilter.includes(group) && !toReturn.includes(participant)) {
                    toReturn.push(participant)
                  }
                })
              } else if (!toReturn.includes(participant)) {
                toReturn.push(participant)
              }
            }
          })

          //    console.log('dfasdfsadf', toReturn)
          return toReturn

        },
          filteredByGroupParticipants() {
              console.log('in filteredByGroupParticipants')
              var toReturn = []

               this.$structuredData.participants.forEach((participant)=>{
                   if(!participant.disabled) {
                       if (this.participantGroupFilter.length > 0) {
                           participant.Group.forEach((group) => {
                               if (this.participantGroupFilter.includes(group) && !toReturn.includes(participant)) {
                                   toReturn.push(participant)
                               }
                           })
                       } else if (!toReturn.includes(participant)) {
                           toReturn.push(participant)
                       }
                   }
              })

          //    console.log('dfasdfsadf', toReturn)
              return toReturn

          },
        filteredResults() {
            if(this.filterQuery == null) {
                this.filterQuery = ''
            }
            this.filterQuery = this.filterQuery.toLowerCase()
            var vueThis = this
            var participants = this.$structuredData.participants.filter(function(participant) {
                return participant.firstName.toLowerCase().includes(vueThis.filterQuery)
                    || participant.lastName.toLowerCase().includes(vueThis.filterQuery)
                    || participant.email.toLowerCase().includes(vueThis.filterQuery)
                    || participant.phone.toLowerCase().includes(vueThis.filterQuery)
                    || participant.parentEmail.toLowerCase().includes(vueThis.filterQuery)
                    || participant.parentPhone.toLowerCase().includes(vueThis.filterQuery)
            });


            var toReturn = []

            participants.forEach((participant)=>{
                participant.resultType="participant"

              if(participant.parentEmail.toLowerCase().includes(vueThis.filterQuery) || participant.parentPhone.toLowerCase().includes(vueThis.filterQuery)) {
                participant.icon = "fas fa-user"
              } else {
                participant.icon = "fas fa-bed"
              }


                toReturn.push(participant)
            })






            console.log('returning....!!!!', toReturn)

            return toReturn
        }

      }
}
</script>
<style>

  .overdueTable .theme--light.v-table thead th{
    color: black !important;
  }

  .waivedFee td {
    text-decoration: line-through !important;
  }

  .paymentSummaryTable .theme--light.v-table tbody tr td,
  .paymentSummaryTable .theme--light.v-table thead th
  {
    padding: 0 5px !important;
  }
</style>

<style scoped lang="scss">


  .admin-dashboard {

    .participantSummarySubHeader {
      background: #727273;
      color: white;
      font-weight: 800;
    }


    .selectedSearchResult {
      background-color: #c9ceea;
      border-bottom: 2px black solid;
      border-top: 2px black solid;
    }
  }

  .summaryParticipantBoxes {

    .BottomLabels {
      text-decoration: overline;
      font-size: 12px;
      position: relative;
      top: -3px;
    }

    .topTextBottomLabels {
      //font-size: 15px;
    }

  }


  .selectedFilter {
      background-color: #1976d2;
      color: white;
  }
  .director-dashboard { }


  .selectedSearchResult {
      background-color: #c9ceea;
      border-bottom: 2px black solid;
      border-top: 2px black solid;
  }


  .tripStatBoxes>div:hover{
      cursor: pointer;
      background-color: #1976d2e6;
      color: white;
  }

  .paymentDueDates {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    gap: 6px 20px;
  }

  .paymentDueDate {
    display: inline-flex;
    flex-direction: column;
    min-width: 110px;
    text-align: center;
  }

  .paymentDueDate small {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .04em;
    text-transform: uppercase;
  }

  .paymentDueHeading {
    align-items: center;
    display: flex;
    gap: 2px;
    justify-content: center;
  }

  .paymentDueDate__pastIcon {
    color: #727273;
    font-size: 13px;
  }

  .paymentDueDate--deposit .paymentDueLabel { color: #6f747a !important; }
  .paymentDueDate--installment1 .paymentDueLabel { color: #626970 !important; }
  .paymentDueDate--installment2 .paymentDueLabel { color: #555c63 !important; }
  .paymentDueDate--installment3 .paymentDueLabel { color: #484f56 !important; }
  .paymentDueDate--installment4 .paymentDueLabel { color: #3b4249 !important; }


</style>
